<template>
  <span class="instant-litigant-verification-style" v-if="litigant.isShowLitigantVerification">
    <template>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span>
            <v-icon
                v-bind="attrs"
                v-on="on"
                large
                :color="litigant.color"
                @click="resolvedLitigant"
            >gavel</v-icon>
          </span>
        </template>
        <span>{{litigant.hoverMessage}}</span>
      </v-tooltip>
    </template>
  </span>
</template>

<script>
import { DataType, Tool, Popup } from '@/util/index'
import { OriginationBusinessApi } from '@/api/pandaria'
const tool = new Tool()
const popup = new Popup()
export default {
  props: {
    loan: Object,
    operator: Object
  },
  data () {
    return {
      litigant: {
        isShowLitigantVerification: false,
        color: '#F44336',
        hoverMessage: ''
      },
      litigantType: '',
      locked: ''
    }
  },
  computed: {
    loanId () {
      return this.loan.loanId
    },
    loanStatus () {
      return this.loan.loanStatus
    },
    operatorId () {
      return this.operator.id
    }
  },
  watch: {
    loanId () {
      this.getLitigantType()
    }
  },
  mounted () {
    this.$eventBus.$on('instantLitigantVerification', target => {
      if (tool.isNotEmpty(target)) {
        this.initIsShowLitigant(target.status)
      }
    })
    this.$eventBus.$on('broadcastLockedId', target => {
      this.locked = target
    })
  },
  methods: {
    initIsShowLitigant (litigantType) {
      this.litigantType = litigantType
      if (litigantType === DataType.LitigantTypeEnum.NO_LITIGANT.value) {
        this.litigant.isShowLitigantVerification = false
      } else {
        this.litigant.isShowLitigantVerification = true
        if (litigantType === DataType.LitigantTypeEnum.UNKNOWN.value) {
          this.litigant.color = '#FF9700'
          this.litigant.hoverMessage = DataType.LitigantTypeEnum.UNKNOWN.text
        } else if (litigantType === DataType.LitigantTypeEnum.LITIGANT.value) {
          this.litigant.color = '#F44336'
          this.litigant.hoverMessage = DataType.LitigantTypeEnum.LITIGANT.text
        }
      }
    },
    getLitigantType () {
      const $this = this
      OriginationBusinessApi.getLitigantType({ loanId: this.loanId }, function (result) {
        if (tool.isNotEmpty(result)) {
          $this.initIsShowLitigant(result.status)
        }
      })
    },
    resolvedLitigant () {
      const $this = this
      const loanStatus = this.loanStatus
      if (loanStatus === DataType.LoanStatus.AGENT_REVIEW.value || loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value || loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        if (this.locked === this.operatorId) {
          if (this.litigantType === DataType.LitigantTypeEnum.UNKNOWN.value) {
            popup.popupForQuestion('Reverify the litigant?', { title: 'Please Confirm' }, function () {
              OriginationBusinessApi.verifyLitigant({ loanId: $this.loanId }, function (result) {
                $this.initIsShowLitigant(result.status)
              }, function (error) {
                popup.popupForWarning(error.message)
              })
            })
          }
        } else {
          popup.popupForWarning('Current loan is locked by others')
        }
      } else {
        popup.popupForWarning('Litigant cannot be verified for the loan in this status, please change the loan status to Agent Review ,Corrector Review or Application Review firstly. ')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.instant-litigant-verification-style {
  border-top-right-radius: 6px;
  display: block;
  position: relative;
  float: right;
  color: white;
  opacity: 0.88;
  height: 10px;
  margin-right: 10px;
  margin-top: 1px;
}
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 48px; }
.group {
  display: flex;
  flex: 1;
  justify-content: space-around;
}
</style>
